export default __webpack_public_path__ + "img/profile_header-84a04db99dcfe788b4e4c388f2267d5f.png";